import { render, staticRenderFns } from "./ModalDocumentos.vue?vue&type=template&id=4eb512cf&scoped=true"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentos.vue?vue&type=style&index=0&id=4eb512cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb512cf",
  null
  
)

export default component.exports